import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store';
import { IPlayer } from '../common/types';
import {addUpdatePlayerToStorage, deletePlayerFromStorage, getPlayersFromStorage} from "../common/utils/storagePlayers";

interface PlayerState {
    players: IPlayer[]
}

const initialState: PlayerState = {
    players: []
};

export const playersSlice = createSlice({
    name: 'players',
    initialState,
    reducers: {
        preloadPlayers: (state) => {
            const storedPlayers:IPlayer[] = getPlayersFromStorage();
            const existingIds = state.players.map(({id}) => (id));

            state.players.push(...storedPlayers.filter(({id}) => !existingIds.includes(id)));
        },
        addPlayer: (state, action: PayloadAction<IPlayer>) => {
            state.players = [...state.players.filter(({id}) => action.payload.id !== id), action.payload];
            addUpdatePlayerToStorage(action.payload);
        },
        deletePlayer: (state, action: PayloadAction<string>) => {
            state.players = state.players.filter(player => player.id !== action.payload);
            deletePlayerFromStorage(action.payload);
        },
        updatePlayer: (state, action: PayloadAction<IPlayer>) => {
            const player = state.players.find(player => player.id === action.payload.id);
            if (player){
                player.name = action.payload.name;
                player.avatarUrl = action.payload.avatarUrl;
                addUpdatePlayerToStorage(action.payload);
            }
        }
    }
});

export const { preloadPlayers, addPlayer, deletePlayer, updatePlayer } = playersSlice.actions;

export const getPlayers = (state: RootState) => state.game.players;

export default playersSlice.reducer
